import { Box, Typography } from "@mui/material";

const InputCharactersCountWrapper = ({ value = "", maxLength, width, children }) => {
  const safeValue = value == null ? "" : String(value);
  const remaining = maxLength - safeValue.length;
  const isError = remaining < 0;

  return (
    <Box sx={{ position: "relative", width: width }}>
      {children}

      <Typography
        variant="caption"
        sx={{
          position: "absolute",
          bottom: 3,
          right: 12,
          pointerEvents: "none",
          color: isError ? "error.main" : "text.secondary",
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          px: 0.5,
          borderRadius: 1,
        }}
      >
        {safeValue.length} / {maxLength}
      </Typography>
    </Box>
  );
};

export default InputCharactersCountWrapper;